module.exports = __webpack_public_path__ + "static/media/zoho.89eef0eb.png";